// Backend base URL for this deployment's own races. Defaults to the nytatime
// (main) backend; the standalone deployment overrides it at build time.
export const API_BASE =
  process.env.REACT_APP_API_BASE ?? "https://Biathlontiming-cdn-endpoint.azureedge.net";

// Optional second backend whose races are also listed on the index. Set this on
// live.biathlontiming.se so one page shows both nytatime and standalone races.
export const STANDALONE_API_BASE = process.env.REACT_APP_STANDALONE_API_BASE ?? "";

export const STANDALONE_SOURCE = "standalone";

// Backends the index lists. Each race is tagged with its source so the results
// page can query the right backend (/?raceId=<id>&src=standalone).
export const RACE_SOURCES = [
  { src: "", base: API_BASE },
  ...(STANDALONE_API_BASE ? [{ src: STANDALONE_SOURCE, base: STANDALONE_API_BASE }] : []),
];

// Resolves which backend to fetch a single race's results from. Falls back to this
// deployment's own base, which is what we want on the standalone results site: there
// API_BASE already is the standalone backend, so a stray ?src=standalone still works.
export function apiBaseForSource(src) {
  if (src === STANDALONE_SOURCE && STANDALONE_API_BASE) {
    return STANDALONE_API_BASE;
  }
  return API_BASE;
}
